export const defaultValue = {
    id: '',
    branchName: '',
};
